import { Link } from 'react-router-dom'
import { ArrowLeft, Mail, Clock, Heart, Star, Users, Zap, Shield, BookOpen } from 'lucide-react'
import * as stylex from '@stylexjs/stylex'
import { styles } from '@/styles/SupportPage.stylex'

export default function SupportPage() {
    return (
        <div {...stylex.props(styles.supportPage)}>
            {/* Header Navigation */}
            <Link to="/" {...stylex.props(styles.backLink)}>
                <ArrowLeft size={20} />
                Back to Home
            </Link>

            {/* Hero Section */}
            <section {...stylex.props(styles.heroSection)}>
                <div {...stylex.props(styles.heroContent)}>
                    <div {...stylex.props(styles.heroIcon)}>
                        <Heart size={80} />
                    </div>
                    <h2 {...stylex.props(styles.heroTitle)}>We're Here to Help You Succeed! 💪</h2>
                    <p {...stylex.props(styles.heroDescription)}>
                        At AiBrush, your success is our mission. Whether you're a creative professional,
                        a content creator, or just exploring the amazing world of AI, we've got your back
                        every step.
                    </p>
                    <div {...stylex.props(styles.heroStats)}>
                        <div {...stylex.props(styles.stat)}>
                            <Clock size={20} {...stylex.props(styles.statIcon)} />
                            <span>24h Response Time</span>
                        </div>
                        <div {...stylex.props(styles.stat)}>
                            <Users size={20} {...stylex.props(styles.statIcon)} />
                            <span>Expert Support Team</span>
                        </div>
                        <div {...stylex.props(styles.stat)}>
                            <Star size={20} {...stylex.props(styles.statIcon)} />
                            <span>5-Star Support</span>
                        </div>
                    </div>
                </div>
            </section>

            {/* Contact Section */}
            <section {...stylex.props(styles.supportPage)}>
                <div {...stylex.props(styles.sectionHeader)}>
                    <Mail size={32} {...stylex.props(styles.sectionHeaderIcon)} />
                    <h3 {...stylex.props(styles.sectionHeaderH3)}>Get in Touch</h3>
                    <p {...stylex.props(styles.sectionHeaderP)}>We'd love to hear from you and help solve any challenges you're facing!</p>
                </div>

                <div {...stylex.props(styles.contactCard)}>
                    <div {...stylex.props(styles.contactInfo)}>
                        <h4 {...stylex.props(styles.contactInfoH4)}>📧 Email Support</h4>
                        <p {...stylex.props(styles.emailAddress)}>
                            <a
                                href="mailto:support@aibrush.co?subject=Support%20Request%20-%20AIBrush"
                                {...stylex.props(styles.emailLink)}
                            >
                                support@aibrush.co
                            </a>
                        </p>
                        <p {...stylex.props(styles.responseTime)}>
                            <Clock size={16} />
                            We typically respond within 24 hours
                        </p>
                    </div>

                    <div {...stylex.props(styles.heroContent)}>
                        <h5 {...stylex.props(styles.emailGuidelinesH5)}>📝 To help us assist you faster, please include:</h5>
                        <ul {...stylex.props(styles.guidelinesList)}>
                            <li {...stylex.props(styles.guidelineItem)}><strong>Subject Line:</strong> Brief summary (e.g., "Billing Question" or "Technical Issue")</li>
                            <li {...stylex.props(styles.guidelineItem)}><strong>Description:</strong> Detailed explanation of your concern</li>
                            <li {...stylex.props(styles.guidelineItem)}><strong>Account Info:</strong> Your username or email (if applicable)</li>
                            <li {...stylex.props(styles.guidelineItem)}><strong>Screenshots:</strong> Any relevant images that might help</li>
                            <li {...stylex.props(styles.guidelineItem)}><strong>Steps to Reproduce:</strong> What you were doing when the issue occurred</li>
                        </ul>
                    </div>
                </div>
            </section>

            {/* Help Categories */}
            <section {...stylex.props(styles.helpCategories)}>
                <h3 {...stylex.props(styles.helpCategoriesH3)}>How Can We Help You Today?</h3>
                <div {...stylex.props(styles.categoriesGrid)}>
                    <div {...stylex.props(styles.categoryCard)}>
                        <Zap size={32} {...stylex.props(styles.categoryIcon)} />
                        <h4 {...stylex.props(styles.categoryH4)}>Technical Support</h4>
                        <p {...stylex.props(styles.categoryP)}>Issues with AI models, generation errors, or platform problems</p>
                    </div>
                    <div {...stylex.props(styles.categoryCard)}>
                        <Shield size={32} {...stylex.props(styles.categoryIcon)} />
                        <h4 {...stylex.props(styles.categoryH4)}>Account & Billing</h4>
                        <p {...stylex.props(styles.categoryP)}>Credits, subscriptions, payments, and account management</p>
                    </div>
                    <div {...stylex.props(styles.categoryCard)}>
                        <BookOpen size={32} {...stylex.props(styles.categoryIcon)} />
                        <h4 {...stylex.props(styles.categoryH4)}>Usage & Tutorials</h4>
                        <p {...stylex.props(styles.categoryP)}>How to use features, best practices, and creative tips</p>
                    </div>
                </div>
            </section>

            {/* Final CTA */}
            <section {...stylex.props(styles.finalCta)}>
                <div {...stylex.props(styles.heroContent)}>
                    <h3 {...stylex.props(styles.sectionHeaderH3)}>Ready to Get Help?</h3>
                    <p {...stylex.props(styles.sectionHeaderP)}>Don't hesitate to reach out. We're here to make your AI creation journey smooth and enjoyable!</p>
                    <a
                        href="mailto:support@aibrush.co?subject=Support%20Request%20-%20AIBrush"
                        {...stylex.props(styles.ctaButton)}
                    >
                        <Mail size={20} />
                        Send us an Email
                    </a>
                </div>
            </section>
        </div>
    )
}